import moment from "moment";
import { TaskTemplateContext} from "../messages/patient_task"
import { partition } from "lodash";
import JSZip from "jszip";

import {
    declareAiCapability,
    provideAiCapability,
} from "@medflyt/webapp-react/src/modules/ai-omnibar/ai-capability-registry";

// The tasks tab describing its own filter bar. It has three separate date ranges - when the task is
// due, when the certification period ends, and when the task was completed - so each is named for what
// it means rather than being folded into one "from and to".
declareAiCapability({
    id: "patientTasks.filter",
    title: "Filter the patient tasks list",
    effect: "prefill",
    description:
        "Sets the filters on Patients > Care & Task management > Tasks and re-runs its search: the task due range, the task completion range, the certification period end range, the document, task status, task name, contract, caregiver, the patient's status, and a free-text search over the table. Anything left out keeps what the page already has. Only works while that tab is open.",
    location: "the filter bar of the Tasks tab",
    scope: "page",
    permissionKey: "view_patients_section_upcoming_tasks",
    params: [
        { name: "dueFrom", type: "date", required: false, description: "Earliest task due date to include, as yyyy-MM-dd." },
        { name: "dueTo", type: "date", required: false, description: "Latest task due date to include, as yyyy-MM-dd." },
        { name: "completedFrom", type: "date", required: false, description: "Earliest task completion date, as yyyy-MM-dd." },
        { name: "completedTo", type: "date", required: false, description: "Latest task completion date, as yyyy-MM-dd." },
        { name: "certificationEndFrom", type: "date", required: false, description: "Earliest certification period end date, as yyyy-MM-dd." },
        { name: "certificationEndTo", type: "date", required: false, description: "Latest certification period end date, as yyyy-MM-dd." },
        {
            name: "document",
            type: "enum",
            required: false,
            multiple: true,
            options: () => getPatientTaskOptions("documentsMultiSelectOptions"),
            description: "Limit to tasks for these documents."
        },
        {
            name: "taskStatus",
            type: "enum",
            required: false,
            multiple: true,
            options: () => getPatientTaskOptions("upcomingTasksStatusMultiSelectOptions"),
            description: "Limit to tasks in these states."
        },
        {
            name: "taskName",
            type: "enum",
            required: false,
            multiple: true,
            options: () => getPatientTaskOptions("taskNameOptions"),
            description: "Limit to tasks with these names."
        },
        {
            name: "contract",
            type: "enum",
            required: false,
            multiple: true,
            options: () => getPatientTaskOptions("contractNameOptions"),
            description: "Limit to patients on these contracts."
        },
        {
            name: "caregiver",
            type: "enum",
            required: false,
            multiple: true,
            options: () => getPatientTaskOptions("caregiverOptions"),
            description: "Limit to tasks for these caregivers."
        },
        {
            name: "patientStatus",
            type: "enum",
            required: false,
            multiple: true,
            options: () => getPatientTaskOptions("patientStatusesOptions"),
            description: "Limit to patients in these statuses."
        },
        {
            name: "search",
            type: "text",
            required: false,
            searchesFreeText: true,
            description: "Free text the table searches over every column, including patient and task names."
        }
    ],
    examples: [
        "tasks due this week",
        "not completed tasks for active patients on the france contract",
        "tasks completed last month"
    ]
});

let patientTasksScope = () => null;

function getPatientTaskOptions(name) {
    const list = patientTasksScope()?.[name] ?? [];

    return (Array.isArray(list) ? list : []).map((option) => ({
        value: String(option.id),
        label: String(option.label ?? option.name ?? option.id)
    }));
}

//! @ngInject
export function patientsUpcomingTasksCtrl($scope, $rootScope, $q, NgTableParams, toaster, DatabaseApi, $filter, $uibModal, itemSearchPageManager, generalUtils, $window, wildcard, mfModal, tasksService, patientDocumentService, $state, patientLookupService) {
    const MANUAL_SUBMISSION_STRING = "MANUAL_SUBMISSION_STRING";
    $scope.gotData = false;
    // The patients and structured addresses for the tasks on screen, resolved by
    // id in loadItems. The dictionary of every patient stood in for both.
    $scope.patientsMap = new Map();
    $scope.patientAddressesMap = new Map();
    $scope.caregiversMap = new Map();
    $scope.officesMap = DatabaseApi.offices() || {};
    $scope.agencyMembersMap = DatabaseApi.getAgencyMembers() || {};
    $scope.documentTypes = DatabaseApi.patientDocumentTypes();
    $scope.planOfCareTypes = DatabaseApi.plansOfCare();
    $scope.patientTaskTemplates = DatabaseApi.patientTaskTemplates();
    $scope.upcomingTasksGlobalFilter = { val: "" };
    $scope.upcomingTasksInitialDateRanges = {
        from: moment().startOf('month').toDate(),
        to: moment().endOf('month').toDate()
    };
    $scope.upcomingTasksCertificationEndDates = {
        from: "",
        to: ""
    };
    $scope.upcomingTasksCompletionDateRanges = {
        from: "",
        to: ""
    };

    $scope.upcomingTasksFilters = {
        documents: [],
        statuses: [],
        offices: [],
        taskContexts: [],
        cities: [],
        zipCodes: [],
        names: [],
        caregivers: [],
        patientStatuses: [],
        contracts: [],
        taskIssues: [],
        languages: []
    };

    $scope.yesNoOptions = [
        { id: 0, label: 'Yes', value: true },
        { id: 1, label: 'No', value: false }
    ];

    $scope.upcomingTasksStatusMultiSelectOptions = tasksService.statuses;

    $scope.taskContextOptions = [
        { id: 0, label: "Regular", value: TaskTemplateContext.Regular },
        { id: 1, label: "Start of Care", value: TaskTemplateContext.StartOfCare },
        { id: 2, label: "Reassessment", value: TaskTemplateContext.Reassessment },
    ];

    // Only include the specific statuses we want to track and display
    $scope.taskStatusesForStats = ["Completed", "Incompleted", "Broadcasting", "Assigned", "Scheduled", "ScheduledPendingConfirmation", "Canceled"];
    $scope.taskStatusesMap = tasksService.statuses.reduce((acc, status) => {
        // Store the original status object from tasksService.statuses
            acc[status.status] = {
                ...status,  // Keep all original properties
                count: 0    // Add count property
            };
        return acc;
    }, {});
;
$scope.selectedTaskInstance = null;

    $scope.toggleStatusFilter = function(statusObj) {
        // Find the original status object from tasksService.statuses
        const originalStatus = tasksService.statuses.find(s => s.id === statusObj.id);
        if (!originalStatus) return;

        const statusIndex = $scope.upcomingTasksFilters.statuses.findIndex(s => s.id === originalStatus.id);
        if (statusIndex !== -1) {
            $scope.upcomingTasksFilters.statuses.splice(statusIndex, 1);
        } else {
            $scope.upcomingTasksFilters.statuses.push(originalStatus);
        }
        filterUpcomingTasksTable();
    };

    function initStatusCounts() {
        Object.keys($scope.taskStatusesMap).forEach(key => {
            $scope.taskStatusesMap[key].count = 0;
        });
    }

   
    $scope.cityOptions = [];
    $scope.zipCodeOptions = [];
    $scope.taskNameOptions = [];
    $scope.caregiverOptions = [];
    $scope.patientStatusesOptions = [];
    $scope.contractNameOptions = [];

    $scope.assignMultiSelect = () => {
        const selectedTasks = $scope.upcomingTasks.filter(x => x.selected && ["FutureTask", "DraftTask"].includes(x.type));
        if (selectedTasks.length === 0) {
            return toaster.pop("warning", "No tasks selected");
        }
        const templateIds = [...new Set(selectedTasks.map(x => x.taskTemplateId))];
        const templates = $scope.patientTaskTemplates.filter(x => templateIds.includes(x.id)).map(x => x.allowedCertifications);
        const allowedCertifications = templates.reduce((acc, curr) => generalUtils.intersect(acc, curr));

        let newScope = $scope.$new();
        newScope.allowedCertifications = allowedCertifications

        const modalInstance = $uibModal.open({
            templateUrl: 'admin/views/patient-task-assign-multiple-modal.html',
            size: 'sm',
            controller: 'patientTaskAssignMultipleModal',
            scope: newScope,
            windowClass: "patient-task-assign-multiple-modal"
        });

        modalInstance.result.then(caregiverId => {
            const url = `agencies/:agencyId/agency_members/:agencyMemberId/assign_patient_tasks`
                .replace(":agencyId", $rootScope.agencyId)
                .replace(":agencyMemberId", $rootScope.agencyMemberId);

            DatabaseApi.post(
                url,
                {
                    tasks: convertDocumentsArray(selectedTasks),
                    caregiverId: caregiverId,
                    isBroadcasting: false,
                }
            ).then(() => loadItems());
        }, () => {});
    }

    let filterModalInstance;
    let upcomingTasksTableDateRangeChangedLoaded = false;

    function convertDocumentsArray(tasks) {
        return tasks.map(task => ({
            ...task,
            documents: task.documents === undefined
                ? undefined
                : task.documents.map(document => document.id)
                    .filter(documentId => Boolean(documentId))
        }));
    }

    function initialize() {
        // No longer gated on the caregiver dictionary: the caregivers on the
        // rows are resolved by id when the page loads them.
        $scope.gotData = true;
        setPlanOfCareType();
        setOfficeMultiSelectOptions();
        setDocumentsMultiSelectOptions();
        initPageManager();
        loadItems();
    }


    patientTasksScope = () => $scope;

    const releasePatientTasksFilter = provideAiCapability("patientTasks.filter", (args) => {
        const applied = [];
        const asList = (value) => (Array.isArray(value) ? value : [value]);
        const asDate = (text) => {
            const parts = String(text).split("-").map(Number);

            if (parts.length !== 3 || parts.some(isNaN)) {
                throw new Error("Could not read the date " + text + ".");
            }

            return new Date(parts[0], parts[1] - 1, parts[2]);
        };
        const pickAll = (listName, requested, what) => {
            const available = $scope[listName] ?? [];
            const wanted = asList(requested).map((one) => String(one).toLowerCase());
            const chosen = (Array.isArray(available) ? available : []).filter(
                (option) =>
                    wanted.includes(String(option.id).toLowerCase()) ||
                    wanted.includes(String(option.label ?? "").toLowerCase()) ||
                    wanted.includes(String(option.name ?? "").toLowerCase()) ||
                    wanted.includes(String(option.value ?? "").toLowerCase())
            );

            if (chosen.length === 0) {
                throw new Error(
                    "Nothing on this page has " + what + " " + asList(requested).join(" or ") + "."
                );
            }

            return chosen;
        };

        for (const [param, arg, label] of [
            ["taskStartDate", args.dueFrom, "due from"],
            ["taskDueDate", args.dueTo, "due to"],
            ["taskCompletionDateFrom", args.completedFrom, "completed from"],
            ["taskCompletionDateTo", args.completedTo, "completed to"],
            ["certificationPeriodEndFrom", args.certificationEndFrom, "certification ending from"],
            ["certificationPeriodEndTo", args.certificationEndTo, "certification ending to"]
        ]) {
            if (arg === undefined) {
                continue;
            }

            $scope.pageManager.updateSearchParamValue(param, asDate(arg));
            applied.push(label + " " + arg);
        }

        for (const [arg, listName, filterName, what] of [
            ["document", "documentsMultiSelectOptions", "documents", "document"],
            ["taskStatus", "upcomingTasksStatusMultiSelectOptions", "statuses", "task status"],
            ["taskName", "taskNameOptions", "names", "task name"],
            ["contract", "contractNameOptions", "contracts", "contract"],
            ["caregiver", "caregiverOptions", "caregivers", "caregiver"],
            ["patientStatus", "patientStatusesOptions", "patientStatuses", "patient status"]
        ]) {
            if (args[arg] === undefined) {
                continue;
            }

            const chosen = pickAll(listName, args[arg], what);

            $scope.upcomingTasksFilters[filterName] = chosen;
            applied.push(chosen.map((option) => option.label ?? option.name).join(" and "));
        }

        if (args.search !== undefined) {
            $scope.upcomingTasksGlobalFilter.val = String(args.search);
            $scope.applyUpcomingTasksGlobalSearch($scope.upcomingTasksGlobalFilter.val);
            applied.push('"' + String(args.search) + '"');
        }

        // The dropdowns are watched and re-filter in the browser; a date range is a server search.
        if (
            args.dueFrom !== undefined || args.dueTo !== undefined ||
            args.completedFrom !== undefined || args.completedTo !== undefined ||
            args.certificationEndFrom !== undefined || args.certificationEndTo !== undefined
        ) {
            loadItems();
        }

        return applied.length === 0
            ? "Re-applied the task filters"
            : "Showing tasks: " + applied.join(", ");
    });

    $scope.$on("$destroy", releasePatientTasksFilter);

    function initPageManager() {
        $scope.pageManager = itemSearchPageManager.createSearchPageManager("/patient_task_instances");
        $scope.pageManager.initFromToDateParams(false, true, "taskStartDate", "taskDueDate");
        $scope.pageManager.initFromToDateParams(false, false, "certificationPeriodEndFrom", "certificationPeriodEndTo");
        $scope.pageManager.initFromToDateParams(false, false, "taskCompletionDateFrom", "taskCompletionDateTo");
        
        // Initialize the taskIssues parameter
        $scope.pageManager.initSearchParam("taskIssues", [], "array");
        $scope.pageManager.updateSearchParamValue("taskStartDate", $scope.upcomingTasksInitialDateRanges.from);
        $scope.pageManager.updateSearchParamValue("taskDueDate", $scope.upcomingTasksInitialDateRanges.to);
        $scope.pageManager.updateSearchParamValue("certificationPeriodEndFrom", "");
        $scope.pageManager.updateSearchParamValue("certificationPeriodEndTo", "");
        $scope.pageManager.updateSearchParamValue("taskCompletionDateFrom", "");
        $scope.pageManager.updateSearchParamValue("taskCompletionDateTo", "");
        $scope.pageManager.initSearchParam("languages", [], "array");
    };

    $scope.resetCertificationPeriodEndRange = () => {
        $scope.pageManager.updateSearchParamValue("certificationPeriodEndFrom", "");
        $scope.pageManager.updateSearchParamValue("certificationPeriodEndTo", "");
        $scope.hasValueCertificationPeriodEnd = false;
        loadItems();
    };

    $scope.resetCompletionDateRange = () => {
        $scope.pageManager.updateSearchParamValue("taskCompletionDateFrom", "");
        $scope.pageManager.updateSearchParamValue("taskCompletionDateTo", "");
        $scope.hasValueCompletionDate = false;
        loadItems();
    };

    function loadItems() {
        $scope.pageManager.executeSearch().then((res) => {
            const patientIds = Array.from(new Set(res.data.patientTaskInstances.map(x => x.patientId)));
            // Both the caregivers and the patients for these tasks arrive with them.
            $scope.caregiversMap = new Map(
                (res.data.caregivers ?? []).map((caregiver) => [String(caregiver.id), caregiver])
            );
            $scope.patientsMap = new Map(
                (res.data.patients ?? []).map((patient) => [String(patient.id), patient])
            );
            // The structured address (city, zip, neighborhood) is a different
            // projection from the patient row, and its endpoint has always taken
            // ids, so it stays a separate request.
            patientLookupService.addressesByIds(patientIds)
                .then((addresses) => {
                    $scope.patientAddressesMap = addresses;
                    mapUpcomingTasks(res.data.patientTaskInstances);
                    setCityOptions();
                    setZipCodeOptions();
                    setTaskNameOptions();
                    setCaregiverOptions();
                    setPatientStatusesOptions();
                    setContractOptions();
                    filterUpcomingTasksTable();
                });
        }, (err) => {
            toaster.pop("error", "Failed to load upcoming tasks");
        });
    };

    function mapUpcomingTasks(tasks) {
        $scope.upcomingTasks = [];
        $scope.documentsOptionsMap = {};
        $scope.officeOptionsMap = {};

        // Reset all status counts
        initStatusCounts();

        tasks.forEach(function (task) {
            enrichPatientTask(task);
            $scope.upcomingTasks.push(task);
            
            // Increment the count for this task's status
            if ($scope.taskStatusesMap[task.status]) {
                $scope.taskStatusesMap[task.status].count++;
            }
        });
    }

    function setCityOptions() {
        $scope.cityOptions = [
            ...new Set($scope.upcomingTasks.map(task => task.patientAddress && task.patientAddress.city))
        ].map(city => ({
            id: city,
            label: city
        }));
    }

    function setZipCodeOptions() {
        $scope.zipCodeOptions = [
            ...new Set($scope.upcomingTasks.map(task => task.patientAddress && task.patientAddress.zipCode))
        ].map(zipCode => ({
            id: zipCode,
            label: zipCode
        }));
    }

    function setTaskNameOptions() {
        $scope.taskNameOptions = [
            ...new Set($scope.upcomingTasks.map(task => task.title))
        ].map(taskName => ({
            id: taskName,
            label: taskName
        }));
    }

    function setPatientStatusesOptions() {
        const agencyPatientStatuses = DatabaseApi.agencyPatientStatuses();
        $scope.patientStatusesOptions = agencyPatientStatuses.map(status => ({
            id: status.text,
            label: status.text.toLowerCase().replace(/_/g, " ")
        }));
    }

    function setContractOptions() {
        $scope.contractNameOptions = [
            ...new Set($scope.upcomingTasks.map(task => task.patientContractName))
        ].filter(Boolean)
        .map((contractName, index) => ({
            id: contractName,
            label: contractName
        }));
    }

    function setCaregiverOptions() {
        $scope.caregiverOptions = [
            ...new Set($scope.upcomingTasks.map(task => task.caregiver?.displayName))
        ].map(caregiverName => ({
            id: caregiverName,
            label: caregiverName
        }));
    }

    const openPatientTaskInstanceDocument = (docId, patientId) => {
        if (!docId|| !patientId) {
            return;
        }

        const url = 'agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId
            + "/patients/" + patientId + '/scheduled_documents/' + docId + "/generate_url";

        DatabaseApi.get(url).then(function (res) {
            $window.open(res.data.fileUrl);
        }, function (err) {
            toaster.pop('error', 'Something went wrong', 'Failed to view document pdf');
        });
    }

    const getFileUrl = (documentId, patientId) => {
        const url = 'agencies/' + $rootScope.agencyId + '/agency_members/' + $rootScope.agencyMemberId
            + "/patients/" + patientId + '/scheduled_documents/' + documentId + "/generate_url";

        return DatabaseApi.get(url).then(function (res) {
            return res.data.fileUrl;
        });
    }
    const openPatientTaskPlanOfCareDocument = (planOfCareId) => {
        if (!planOfCareId) {
            return;
        }

        const url = wildcard(
            "agencies/:agencyId/agency_members/:agencyMemberId/plan_of_care/:planOfCareId/signed_url",
            $rootScope.agencyId,
            $rootScope.agencyMemberId,
            planOfCareId
        );

        DatabaseApi.get(url).then(function (res) {
            $window.open(res.data.url);
        }, function (err) {
            toaster.pop('error', 'Something went wrong', 'Failed to view plan of care document pdf');
        });
    }

    const sendPatientTaskDocumentPDFEmail = (document, patientId, type) => {
        const patient = $scope.patientsMap.get(String(patientId));
        if (!patient) {
            return;
        }
        let docsType = type === 'planOfCare' ? 'planOfCare' : 'patient';
        $uibModal.open({
            templateUrl: 'admin/views/email-modal.html',
            size: 'lg',
            resolve: {
                documents: function () { return [document]; },
                patientId: function () { return patientId; },
                patientFullName: function () { return patient.displayName; },
                docsType: function () { return (docsType); }
            },
            controller: 'emailModalCtrl'
        });
    };

    const sendPatientTaskDocumentPDFWithMedflytEfax = (document, patientId)  => {
        $uibModal.open({
            templateUrl: "admin/views/send-patient-document-as-fax-modal.html",
            size: "lg",
            resolve: {
                document: function () { return document; },
                patientId: function () { return patientId; },
                type: function () { return "TaskDocument"; }
            },
            controller:  "sendPatientDocumentAsFaxModalCtrl",
        });
    }

    const sendPatientTaskDocumentPDFEfax = (document, patientId) => {
        $uibModal.open({
            templateUrl: 'admin/views/fax-modal.html',
            size: 'lg',
            resolve: {
                documents: function () { return [document]; },
                patientId: function () { return patientId; }
            },
            controller: 'faxModalCtrl'
        });
    };

    const reopenPatientTaskDocumentForSubmission = (instance, document) => {
        patientDocumentService.openResubmissionModal({id: document.documentScheduleId}, () => {
            document.submitted = null;
            document.classNames = 'label-error label-with-options-error';
            setPatientTaskInstanceDocumentsStatisticsAndOptions(instance);
            instance.completionDate = null;
            setTaskStatus(instance);
            toaster.pop('success', "Success", "Document is open for submission");
        });
    }

    const markPatientTaskDocumentAsSentToPhysician = (instance, document) => {
        $uibModal.open({
            templateUrl: 'admin/views/sent-to-physician-document-modal.html',
            controller: 'sentToPhysicianDocumentModalCtrl',
            size: 'sm',
            windowClass: 'center-center',
            resolve: {
                document: () => ({...document, id: document.documentScheduleId}),
                onSuccess: () => ({ sentDate }) => {
                    document.sentToPhysician = true;
                    setPatientTaskInstanceDocumentsStatisticsAndOptions(instance);
                    setTaskStatus(instance);
                }
            },
        });
    }

    const markPatientTaskDocumentAsApproved = (instance, document) => {
        $uibModal.open({
            templateUrl: 'admin/views/approve-patient-document-modal.html',
            controller: 'approvePatientDocumentModalCtrl',
            size: 'sm',
            windowClass: 'center-center',
            resolve: {
                document: ({...document, id: document.documentScheduleId}),
                onSuccess: () => ({ approvedDate }) => {
                    document.approved = true;
                    setPatientTaskInstanceDocumentsStatisticsAndOptions(instance);
                    setTaskStatus(instance);
                }
            },
        });
    }

    const setPatientTaskInstanceDocumentsStatisticsAndOptions = (instance) => {
        instance.filledDocumentsAmount = instance.documents.filter(d =>
            d.submitted === true).length;
        instance.missingDocumentsAmount = instance.documents.filter(d =>
            d.submitted !== true
        ).length;

        instance.documents.forEach(doc => {
            if (doc.submitted) {
                if (doc.approved || doc.sentToPhysician) {
                    doc.classNames = 'label-primary label-with-options-primary';
                } else {
                    doc.classNames = 'label-success label-with-options-success';
                }
            } else {
                doc.classNames = 'label-error label-with-options-error'
            }

            let options = [];
            const documentObj = {
                id: doc.documentScheduleId,
                title: doc.title
            }

            if (doc.submitted && doc.fileUrl && doc.fileUrl !== MANUAL_SUBMISSION_STRING) {
                options.push({ displayText: 'View PDF', callback: openPatientTaskInstanceDocument, callbackParam1: doc.documentScheduleId, callbackParam2: instance.patientId });
                options.push({ displayText: 'Send PDF to e-mail', callback: sendPatientTaskDocumentPDFEmail, callbackParam1: documentObj, callbackParam2: instance.patientId });
                if($rootScope.isOnboardingAgency){
                    options.push({ displayText: 'Send PDF to fax', callback: sendPatientTaskDocumentPDFWithMedflytEfax, callbackParam1: doc, callbackParam2: instance.patientId });
                }
                else {
                    options.push({ displayText: 'Send PDF to fax', callback: sendPatientTaskDocumentPDFEfax, callbackParam1: documentObj, callbackParam2: instance.patientId });
                }
            } 
            
            if (doc.submitted) {
                options.push({
                    displayText: 'Open for submission',
                    callback: reopenPatientTaskDocumentForSubmission,
                    callbackParam1: instance,
                    callbackParam2: doc
                });
                if (!doc.isScanned) {
                    options.push({
                        displayText: 'Review form',
                        callback: reviewForm,
                        callbackParam1: doc,
                        callbackParam2: instance.taskInstanceId,
                        callbackParam3: instance.patientName,
                        callbackParam4: instance.caregiver.displayName,
                        callbackParam5: instance.patientId
                    });
                }

                if (!doc.approved && !doc.sentToPhysician) {
                    options.push({
                        displayText: 'Mark as sent to physician',
                        callback: markPatientTaskDocumentAsSentToPhysician,
                        callbackParam1: instance,
                        callbackParam2: doc
                    });
                }
                if (!doc.approved) {
                    options.push({
                        displayText: 'Mark as Approved',
                        callback: markPatientTaskDocumentAsApproved,
                        callbackParam1: instance,
                        callbackParam2: doc
                    });
                }
            }
            else if (!doc.submitted) {
                options.push({
                    displayText: 'Submit manually',
                    callback: submitPatientTaskDocumentManually,
                    callbackParam1: instance,
                    callbackParam2: doc
                });
                options.push({
                    displayText: 'Mark as submitted',
                    callback: markPatientTaskDocumentAsSubmitted,
                    callbackParam1: instance,
                    callbackParam2: doc
                });
                options.push({
                    displayText: 'Review form',
                    callback: reviewForm,
                    callbackParam1: doc,
                    callbackParam2: instance.taskInstanceId,
                    callbackParam3: instance.patientName,
                    callbackParam4: instance.caregiver.displayName,
                    callbackParam5: instance.patientId
                });
            }

            if (!$scope.documentsOptionsMap[instance.patientTaskInstanceId]) {
                $scope.documentsOptionsMap[instance.patientTaskInstanceId] = {};
            }
            $scope.documentsOptionsMap[instance.patientTaskInstanceId][doc.documentTypeId] = options;
        });
    }

    async function prepareDocumentReplaceConstants(patientName, caregiverName) {
        var data = {};
        data.agencyName = $rootScope.user.agency.name;
        data.caregiverName = caregiverName;
        data.patientName = patientName;
        data.agencyAddress = $rootScope.user.agency.address;
        data.agencyPhone = $filter("americanphone")($rootScope.user.agency.officePhone);
        return data;
    }

    const reviewForm = (document, instanceId, patientName, caregiverName, patientId) => {
        let url = `agencies/${$rootScope.agencyId}/agency_members/${$rootScope.agencyMemberId}/patient_task_instances/${instanceId}/patient_documents/${document.documentTypeId}`;
        DatabaseApi.get(url).then(function (res) {
            var modalInstance = $uibModal.open({
                templateUrl: 'admin/views/edit-patient-doc-modal.html',
                size: 'lg',
                controller: 'editPatientDocModalCtrl',
                resolve: {
                    patientId: patientId,
                    document: res.data.document,
                    documentReplaceConstants: () => prepareDocumentReplaceConstants.bind({}, patientName, caregiverName)
                }
            });

            modalInstance.result.then(function (data) {
                if (data && data.fileUrl && data.date) {
                    document.submittedAt = data.date;
                    document.pdfUrl = data.fileUrl;
                }
            }, function () {});
        }, function () {
            toaster.pop('error', "Something went wrong");
        });
    };

    const submitPatientTaskDocumentManually = (instance, document) => {
        const url = "agencies/:agencyId/agency_member/:agencyMemberId/patient_task_instance/:patientTaskInstanceId/patient_document"
                        .replace(":agencyId", $rootScope.agencyId)
                        .replace(":agencyMemberId", $rootScope.agencyMemberId)
                        .replace(":patientTaskInstanceId", instance.taskInstanceId);
        
        $rootScope.openUploadDocumentPdfModal({
            url: url,
            document: document, successCallback: (result) => {
                if (result !== null) {
                    document.submitted = true;
                    document.documentScheduleId = result.data.id;
                    document.fileUrl = result.data.url;
                    setPatientTaskInstanceDocumentsStatisticsAndOptions(instance);
                }
            }
        });
    }

    const markPatientTaskDocumentAsSubmitted = (instance, document) => {
        const url = "agencies/:agencyId/agency_member/:agencyMemberId/patient_task_instance/:patientTaskInstanceId/patient_document"
                        .replace(":agencyId", $rootScope.agencyId)
                        .replace(":agencyMemberId", $rootScope.agencyMemberId)
                        .replace(":patientTaskInstanceId", instance.taskInstanceId);

        DatabaseApi.post(url,
            {
                base64: null,
                documentId: document.documentTypeId,
                documentVersion: null,
                documentTitle: null
            }
        ).then(function (res) {
            toaster.pop('success', "Manual submission successful", '', ' ');
            document.submitted = true;
            document.documentScheduleId = res.data.id;
            instance.completionDate = res.data.patientTaskInstanceCompletionDate;
            setPatientTaskInstanceDocumentsStatisticsAndOptions(instance);
            setTaskStatus(instance);
        }, function (err) {
            toaster.pop('error', 'Error', 'Manual submission failed');
        });
    }

    function enrichPatientTask(task) {
        let caregiver;
        task.selected = false;
        if (task.caregiverId) {
            caregiver = $scope.caregiversMap.get(String(task.caregiverId));
            if (!caregiver) {
                return;
            }
            task.caregiver = caregiver;
        }

        let relevantDocs = [];
        if (task.planOfCareTypeId && $scope.planOfCare) {
            relevantDocs.push($scope.planOfCare.name)
        }
        // The structured address comes from its own lookup now; the dictionary
        // entry used to carry it after fillPatientsAddress had written it in.
        const address = $scope.patientAddressesMap.get(String(task.patientId));
        task.area = address && address.components && address.components.neighborhood || null;
        task.patientAddress = {
            text: address?.text,
            city: address?.components?.formatedAddressDetails?.city,
            zipCode: address?.components?.formatedAddressDetails?.zip5 ?? address?.components?.formatedAddressDetails?.zip4,
        };
        // Was a free `patient` variable left behind when the patient dictionary
        // lookup that declared it was removed; the resolved patient lives here now.
        task.patientStatus = $scope.patientsMap.get(String(task.patientId))?.status;

        if (task.documents.length > 0 && typeof task.documents[0] === "number") {
            task.documents = task.documents.map(documentId => ({
                ...$scope.documentTypes.find(d => d.id === documentId),
                documentTypeId: documentId
            }));
        }

        task.documents.forEach(doc => {
            if (doc.submitted) {
                if (doc.approved || doc.sentToPhysician) {
                    doc.classNames = 'label-primary label-with-options-primary';
                } else {
                    doc.classNames = 'label-success label-with-options-success';
                }
            } else if (doc.openForResubmission) {
                doc.classNames = 'label-with-options-warning';
            } else {
                doc.classNames = 'label-error label-with-options-error'
            }

            let options = [];
            if (task.type === "RegularTask") {
                const documentObj = {
                    id: doc.documentScheduleId,
                    title: doc.title
                }

                if (doc.submitted && doc.fileUrl && doc.fileUrl !== MANUAL_SUBMISSION_STRING) {
                    options.push({ displayText: 'View PDF', callback: openPatientTaskInstanceDocument, callbackParam1: doc.documentScheduleId, callbackParam2: task.patientId });
                    options.push({ displayText: 'Send PDF to e-mail', callback: sendPatientTaskDocumentPDFEmail, callbackParam1: documentObj, callbackParam2: task.patientId });

                    if($rootScope.isOnboardingAgency){
                        options.push({ displayText: 'Send PDF to fax', callback: sendPatientTaskDocumentPDFWithMedflytEfax, callbackParam1: doc, callbackParam2: task.patientId });
                    }
                    else{
                        options.push({ displayText: 'Send PDF to fax', callback: sendPatientTaskDocumentPDFEfax, callbackParam1: documentObj, callbackParam2: task.patientId });
                    }
                } 
                
                if (doc.submitted) {
                    options.push({
                        displayText: 'Open for submission',
                        callback: reopenPatientTaskDocumentForSubmission,
                        callbackParam1: task,
                        callbackParam2: doc
                    });

                    if (!doc.approved && !doc.sentToPhysician) {
                        options.push({
                            displayText: 'Mark as sent to physician',
                            callback: markPatientTaskDocumentAsSentToPhysician,
                            callbackParam1: task,
                            callbackParam2: doc
                        });
                    }
                    if (!doc.approved) {
                        options.push({
                            displayText: 'Mark as Approved',
                            callback: markPatientTaskDocumentAsApproved,
                            callbackParam1: task,
                            callbackParam2: doc
                        });
                    }
                    if (!doc.isScanned) {
                        options.push({
                            displayText: 'Review form',
                            callback: reviewForm,
                            callbackParam1: doc,
                            callbackParam2: task.taskInstanceId,
                            callbackParam3: task.patientName,
                            callbackParam4: task.caregiver ? task.caregiver.displayName : null,
                            callbackParam5: task.patientId
                        });
                    }
                }
                else if (!doc.submitted) {
                    options.push({
                        displayText: 'Submit manually',
                        callback: submitPatientTaskDocumentManually,
                        callbackParam1: task,
                        callbackParam2: doc
                    });
                    options.push({
                        displayText: 'Mark as submitted',
                        callback: markPatientTaskDocumentAsSubmitted,
                        callbackParam1: task,
                        callbackParam2: doc
                    });
                    options.push({
                        displayText: 'Review form',
                        callback: reviewForm,
                        callbackParam1: doc,
                        callbackParam2: task.taskInstanceId,
                        callbackParam3: task.patientName,
                        callbackParam4: task.caregiver ? task.caregiver.displayName : null,
                        callbackParam5: task.patientId
                    });
                }
                options.push({
                    displayText: 'Delete document',
                    callback: $scope.onClickRemovePatientScheduledDocument,
                    callbackParam1: doc,
                    callbackParam2: task
                });
            }

            if (task.patientTaskInstanceId === undefined || doc.documentTypeId === undefined) {
                task.patientTaskInstanceId = -1;
                doc.documentTypeId = -1;
            }

            if (!$scope.documentsOptionsMap[task.patientTaskInstanceId]) {
                $scope.documentsOptionsMap[task.patientTaskInstanceId] = {};
            }
            $scope.documentsOptionsMap[task.patientTaskInstanceId][doc.documentTypeId] = options;

            task.taskTemplateContextLabel = "Regular";
            if (task.taskTemplateContext === TaskTemplateContext.StartOfCare) {
                task.taskTemplateContextLabel = "Start of Care";
            } else if (task.taskTemplateContext === TaskTemplateContext.Reassessment) {
                task.taskTemplateContextLabel = "Reassessment";
            }
        });

        if (task.planOfCareTypeId) {
            if (task.planOfCare) {
                const pocClassNames = task.planOfCare.submitted ?
                    'label-success label-with-options-success' : 'label-error label-with-options-error';
                task.documents.push({
                    documentTypeId: -1,
                    title: "Plan Of Care",
                    classNames: pocClassNames,
                    submitted: task.planOfCare.submitted
                });

                if (task.planOfCare.submitted && task.planOfCare.fileUrl) {
                    const options = [];
                    options.push({ displayText: 'View PDF', callback: openPatientTaskPlanOfCareDocument, callbackParam1: task.planOfCare.planOfCareId });
                    options.push({
                        displayText: 'Send PDF to e-mail',
                        callback: sendPatientTaskDocumentPDFEmail,
                        callbackParam1: { id: task.planOfCare.planOfCareId },
                        callbackParam2: task.patientId,
                        callbackParam3: 'planOfCare'
                    });
                    
                    if (!$scope.documentsOptionsMap[task.patientTaskInstanceId]) {
                        $scope.documentsOptionsMap[task.patientTaskInstanceId] = {};
                    }
                    $scope.documentsOptionsMap[task.patientTaskInstanceId][-1] = options;
                }
            } else {
                task.documents.push({
                    documentTypeId: -1,
                    title: "Plan Of Care",
                    classNames: 'label-error label-with-options-error'
                });
            }
        }

        task.filledDocumentsAmount = task.documents.filter(d =>
            d.submitted === true).length;
        task.missingDocumentsAmount = task.documents.filter(d =>
            d.submitted !== true
        ).length;

        task.displayForms = false;
    }

    function setTaskStatus(task) {
       task.status = tasksService.getTaskStatus(task).status;
    }

    const upcomingTaskFilterByMethods = {
        taskHasDocuments: function (task, selectedDocuments, hasPlanOfCare) {
            return (task.documents.find(({ documentTypeId }) => selectedDocuments.indexOf(documentTypeId) !== -1) !== undefined)
                || (hasPlanOfCare ? typeof task.planOfCareTypeId === "number" : false);
        },
        taskHasStatus: (task, selectedStatuses) => selectedStatuses.includes(task.status),
        taskIsInOffice: (task, selectedOfficeIds) => selectedOfficeIds.includes(task.patientOfficeId),
        taskIsInContexts: (task, selectedTaskContexts) => selectedTaskContexts.includes(task.taskTemplateContext),
        taskPatientHasStatus: (task, selectedPatientStatuses) => {
            const patientOfTask = $scope.patientsMap.get(String(task.patientId));
            if (patientOfTask === undefined) {
                return false;
            }
            return selectedPatientStatuses.includes(patientOfTask.status);
        },
    };

    function filterUpcomingTasksTable() {
        if (!$scope.upcomingTasks) return;

        let filters = [];

        const selectedPlanOfCareObj = $scope.upcomingTasksFilters.documents.find((doc) => doc.id === 0);
        // filter out plan of care
        const selectedDocuments = $scope.upcomingTasksFilters.documents.map((doc) => doc.id).filter(docId => docId !== 0);
        if (selectedDocuments.length > 0 || selectedPlanOfCareObj) {
            filters.push(task => upcomingTaskFilterByMethods.taskHasDocuments(task, selectedDocuments, selectedPlanOfCareObj ? true : false));
        }

        const selectedStatuses = $scope.upcomingTasksStatusMultiSelectOptions.filter(x => $scope.upcomingTasksFilters.statuses.some(y => y.id === x.id)).map(s => s.status);
        if (selectedStatuses.length > 0) {
            filters.push(task => upcomingTaskFilterByMethods.taskHasStatus(task, selectedStatuses));
        }

        const selectedOfficeIds = $scope.upcomingTasksFilters.offices.map(office => office.id);
        if (selectedOfficeIds.length > 0) {
            filters.push(task => upcomingTaskFilterByMethods.taskIsInOffice(task, selectedOfficeIds));
        }

        const selectedTaskContexts = $scope.upcomingTasksFilters.taskContexts.map(context =>
            $scope.taskContextOptions.find(option => option.id === context.id).value
        );
        if (selectedTaskContexts.length > 0) {
            filters.push(task => upcomingTaskFilterByMethods.taskIsInContexts(task, selectedTaskContexts));
        }

        const selectedPatientStatuses = $scope.upcomingTasksFilters.patientStatuses.map(x => x.id);
        if ($scope.upcomingTasksFilters.patientStatuses.length > 0) {
            filters.push(task => upcomingTaskFilterByMethods.taskPatientHasStatus(task, selectedPatientStatuses));
        }

        if ($scope.upcomingTasksFilters.cities.length > 0) {
            filters.push(
                (task) => $scope.upcomingTasksFilters.cities.map((x) => x.id).includes(task.patientAddress.city)
            );
        }

        if ($scope.upcomingTasksFilters.zipCodes.length > 0) {
            filters.push(
                (task) => $scope.upcomingTasksFilters.zipCodes.map((x) => x.id).includes(task.patientAddress.zipCode)
            );
        }

        if ($scope.upcomingTasksFilters.names.length > 0) {
            filters.push(
                (task) => $scope.upcomingTasksFilters.names.map((x) => x.id).includes(task.title)
            );
        }

        if ($scope.upcomingTasksFilters.caregivers.length > 0) {
            filters.push(
                (task) => $scope.upcomingTasksFilters.caregivers.map((x) => x.id).includes(task.caregiver?.displayName)
            );
        }

        if ($scope.upcomingTasksFilters.contracts.length > 0) {
            filters.push(
                (task) => $scope.upcomingTasksFilters.contracts.map((x) => x.id).includes(task.patientContractName)
            );
        }
        
        if ($scope.upcomingTasksFilters.taskIssues.length > 0) {
            filters.push((task) =>
                task.taskIssues.some((issue) =>
                    $scope.upcomingTasksFilters.taskIssues
                        .map((x) => x.id)
                        .includes(issue.taskIssueTypeCode)
                )
            );
        }

        if ($scope.upcomingTasksFilters.languages.length > 0) {
            filters.push(
                (task) => $scope.upcomingTasksFilters.languages.map((x) => x.id).includes(task.mainLanguage)
            );
        }

        let filteredUpcomingTasks = $scope.upcomingTasks;
        if (filters.length > 0) {
            filteredUpcomingTasks = filteredUpcomingTasks.filter(function (task) {
                var isFiltered = true;
                for (var idx = 0; isFiltered && idx < filters.length; idx++) {
                    isFiltered = isFiltered && filters[idx](task);
                }
                return isFiltered;
            });
        }

        // Reset all status counts before updating with filtered tasks
        initStatusCounts();

        // Update status counts based on filtered tasks
        filteredUpcomingTasks.forEach(task => {
            if ($scope.taskStatusesMap[task.status]) {
                $scope.taskStatusesMap[task.status].count++;
            }
        });

        initUpcomingTasksTable(filteredUpcomingTasks);
    }

    function initUpcomingTasksTable(items) {
        $scope.tableData = items;
        const options = {
            count: 25
        };
        $scope.upcomingTasksTable = new NgTableParams(options, {
            counts: [10, 25, 50, 100],
            getData: function (params) {
                if (!$scope.tableData || $scope.tableData.length === 0) {
                    return [];
                }

                let datesOnly = $scope.tableData.filter(a => a.createdAt !== null && a.createdAt !== undefined);
                let noDates = $scope.tableData.filter(a => a.createdAt === null || a.createdAt === undefined);

                if (params.orderBy().includes('+createdAt')) {
                    datesOnly.sort(function (a, b) {
                        return new Date(a.createdAt) - new Date(b.createdAt)
                    });
                } else {
                    datesOnly.sort(function (a, b) {
                        return new Date(b.createdAt) - new Date(a.createdAt)
                    });
                }
                let data = datesOnly.concat(noDates);
                data = $filter('filter')(data, params.filter());

                params.total(data.length);
                let orderedData = data.slice((params.page() - 1) * params.count(), params.page() * params.count());
                if (params.sorting()) {
                    orderedData = $filter('orderBy')(orderedData, params.orderBy());
                }
                
                return orderedData;
            }
        });

        if ($scope.upcomingTasksGlobalFilter.val) {
            $scope.applyUpcomingTasksGlobalSearch($scope.upcomingTasksGlobalFilter.val);
        }
    }

    $scope.applyUpcomingTasksGlobalSearch = (term) => {
        const filter = { $: term };
        if ($scope.upcomingTasksTable) {
            angular.extend($scope.upcomingTasksTable.filter(), filter);
        }
    };


    $scope.$watch('upcomingTasksFilters', function () {
        filterUpcomingTasksTable();
    }, true);

    $scope.onUpcomingTasksTableDateRangeChanged = (startDate, endDate, fieldName) => {
        if (!upcomingTasksTableDateRangeChangedLoaded && fieldName === "certificationPeriodEnd") {
            upcomingTasksTableDateRangeChangedLoaded = true;
            return;
        }
        if (!$scope.pageManager) {
            return;
        }
        if (fieldName === "taskDateRanges") {
            $scope.pageManager.updateSearchParamValue("taskStartDate", startDate ? new Date(startDate) : "");
            $scope.pageManager.updateSearchParamValue("taskDueDate", endDate ? new Date(endDate) : "");
        } else if (fieldName === "certificationPeriodEnd") {
            $scope.pageManager.updateSearchParamValue("certificationPeriodEndFrom", startDate ? new Date(startDate) : "");
            $scope.pageManager.updateSearchParamValue("certificationPeriodEndTo", endDate ? new Date(endDate) : "");
            $scope.hasValueCertificationPeriodEnd = startDate && endDate;
            $scope.upcomingTasksCertificationEndDates = { from: startDate, to: endDate };
        } else if (fieldName === "taskCompletionDateRange") {
            $scope.pageManager.updateSearchParamValue("taskCompletionDateFrom", startDate ? new Date(startDate) : "");
            $scope.pageManager.updateSearchParamValue("taskCompletionDateTo", endDate ? new Date(endDate) : "");
            $scope.hasValueCompletionDate = startDate && endDate;
            $scope.upcomingTasksCompletionDateRanges = { from: startDate, to: endDate };
        } else {
            return;
        }
        loadItems();
    }

    $scope.preOpenCaregiverModal = (row) => {
        if (!row.caregiverId) return;
        $rootScope.openCaregiverModal(row.caregiverId);
    };

    $scope.preOpenPatientModal = (row) => {
        if (!row.patientId) return;
        $rootScope.openPatientModal(row.patientId);
    }

    $scope.handleAction = (task) => {
        const action = task.status === "Broadcasting"
            ? $scope.stopBroadcast
            : $scope.cancelTask;

        action(task);
    };

    $scope.stopBroadcast = (task) => {
        const modal = mfModal.create({
            subject: "Stop broadcast",
            message: `
                Are you sure you want to stop selected task broadcasts?
            `,
            cancelLabel: "Cancel",
            confirmLabel: "Stop selected broadcasts",
            variant: "danger",
            onConfirm: () => {
                modal.setLoading(true);
        
                const url = wildcard(
                    "agencies/:agencyId/agency_members/:agencyMemberId/patient_task_instances_broadcast/:taskInstanceId",
                    $rootScope.agencyId,
                    $rootScope.agencyMemberId,
                    task.taskInstanceId
                );

                DatabaseApi.delete(url).then((_) => {
                    toaster.pop("success", "Successfully stopped task broadcast");
                    $rootScope.$emit("patient_task_saved");
                    modal.close();
                    loadItems();
                }, (err) => {
                    if (err.status === 409) {
                        toaster.pop("error", "Can't Stop Broadcast", "A caregiver has already taken the visit. Please refresh the page to see the updated information.");
                        modal.update({
                            isLoading: false,
                            message: "A caregiver has already taken the visit. Please refresh the page to see the updated information.",
                        });
                    } else {
                        toaster.pop("error", "Something went wrong", errText || err.data);
                        modal.update({
                            isLoading: false,
                            message: "Something went wrong, please try again.",
                        });
                    }
                });
            }
        });
    };

    $scope.cancelTask = (task) => {
        let newScope = $scope.$new();
        newScope.task = task;
        const modalInstance = $uibModal.open({
            templateUrl: 'admin/views/patient-upcoming-task-cancel-modal.html',
            size: 'md',
            controller: 'patientUpcomigTaskCancelModalCtrl',
            scope: newScope,
        });

        modalInstance.result.then(() => {
            loadItems();
        }, function () { });
    }

    $scope.openNewPatientTaskModal = (task) => {
        let newScope = $scope.$new();
        newScope.task = null;
        newScope.type = null;
        
        const isNewTask = task === undefined;
        
        if (task) {
            newScope.task = task;
            newScope.task.documents = newScope.task.documents.filter(doc => doc !== undefined).map(doc => doc.id);
            newScope.type = task.type;
        }

        newScope.documentsMultiSelectOptions = newScope.documentsMultiSelectOptions.filter(doc => {
            if (doc.isPlanOfCare) {
                return true;
            }

            const document = newScope.documentTypes.find(d => d.id === doc.id);
            return document && document.versions && document.versions.find(v => v.isPublished) !== undefined;
        });

        // add plan of care to array with unique id '0'
        if ($scope.planOfCare) {
            newScope.documentsMultiSelectOptions.push({
                id: 0,
                label: $scope.planOfCare.name,
                isPlanOfCare: true
            });
        }

        const modalInstance = $uibModal.open({
            templateUrl: 'admin/views/new-patient-task-modal.html',
            size: 'lg',
            controller: 'newPatientTaskModalCtrl',
            scope: newScope,
            windowClass: "new-patient-task-modal"
        });

        modalInstance.result.then(function (res) {
            patientLookupService.addressesByIds([res.patientId]).then((addresses) => {
                addresses.forEach((address, key) => { $scope.patientAddressesMap.set(key, address); });
                // The modal returns the task with its caregiver on it.
                if (res.caregiver) {
                    $scope.caregiversMap.set(String(res.caregiver.id), res.caregiver);
                }
                if (res.taskId) {
                    $scope.newRowPatientTaskInstanceId = res.patientTaskInstanceId;
                    enrichPatientTask(res);

                    if (isNewTask) {
                        $scope.upcomingTasks.push(res);
                    } else {
                        const index = $scope.upcomingTasks.findIndex(task => task.taskId === res.taskId);
                        $scope.upcomingTasks[index] = res;
                    }

                    filterUpcomingTasksTable();
                }
            })
        }, function () {
        });
    }

    $scope.selectUpcomingTasksDocumentsExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '250px',
        enableSearch: true
    };

    $scope.selectOfficesExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '250px',
        enableSearch: true
    };

    $scope.selectCitiesExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '500px',
        enableSearch: true
    };

    $scope.selectZipCodesExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '500px',
        enableSearch: true
    };

    $scope.selectTaskNameExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '500px',
        enableSearch: true
    };

    $scope.selectCaregiverExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '500px',
        enableSearch: true
    };

    $scope.selectPatientStatusesExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '500px',
        enableSearch: true
    };

    $scope.selectUpcomingTasksStatusesExtraSettings = {
        styleActive: true,
        scrollable: true
    };

    $scope.selectUpcomingTaskSingleFiltersExtraSettings = {
        styleActive: true,
        selectionLimit: 1,
        singleSelection: true,
        smartButtonMaxItems: 1
    };

    $scope.selectUpcomingTasksContextsExtraSettings = {
        styleActive: true,
        smartButtonMaxItems: 3,
    };

    $scope.selectContractExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '500px',
        enableSearch: true
    };

    $scope.taskIssuesMultiSelectSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '500px',
        enableSearch: true
    };

    $scope.selectLanguagesExtraSettings = {
        styleActive: true,
        scrollable: true,
        scrollableHeight: '500px',
        enableSearch: true
    };

    $scope.openFilterModal = () => {
        filterModalInstance = $uibModal.open({
            templateUrl: 'admin/views/patients-upcoming-tasks-filters-modal.html',
            size: 'md',
            scope: $scope,
            resolve: {},
            backdrop: true,
            backdropClass: 'transparent-backdrop',
            windowClass: "modal modal-slide-in-right uib-side-modal"
        });

        filterModalInstance.closed.then(() => upcomingTasksTableDateRangeChangedLoaded = false);

        return filterModalInstance;
    }

    $scope.closeFilterModal = () => {
        filterModalInstance?.close();
    };

    function setOfficeMultiSelectOptions() {
        if (!$scope.officesMap) {
            return;
        }

        $scope.officeTaskMultiSelectOptions = $scope.officesMap.map(office => ({id: office.id, label: office.name}));
    }

    function setDocumentsMultiSelectOptions() {
        if (!$scope.documentTypes) {
            return;
        }

        $scope.documentsMultiSelectOptions = $scope.documentTypes
            .filter(doc => doc.title !== "")
            .map(doc => ({ id: doc.id, label: doc.title }));

        // add plan of care to array with unique id '0'
        if ($scope.planOfCare) {
            $scope.documentsMultiSelectOptions.push({
                id: 0,
                label: $scope.planOfCare.name,
                isPlanOfCare: true
            })
        }
    }

    function setPlanOfCareType() {
        if (!$scope.planOfCareTypes || $scope.planOfCareTypes.length === 0) {
            return;
        }

        $scope.planOfCare = $scope.planOfCareTypes[0];
    }

    const handleConfirmRemoveScheduledDocument = (document, task) => {

        tasksService
        .deletePatientTaskDocument(task.patientId, task.taskInstanceId, document.documentTypeId)
        .then(() => {
            toaster.pop("success", "Document successfully deleted");
            task.documents = task.documents.filter(doc => doc.documentTypeId !== document.documentTypeId);
            task.missingDocumentsAmount -= 1;

            if (task.documents.length === 0) {
                const taskIndex = $scope.upcomingTasks.findIndex(t => t.taskInstanceId === task.taskInstanceId);
                $scope.upcomingTasks.splice(taskIndex, 1);
                filterUpcomingTasksTable();
            }
        })
        .catch(() => {
            toaster.pop("error", "Something went wrong", "Failed to delete document");
        })
    };

    $scope.exportTable = function () {
        $scope.loadingCSV = true;
        var rows = [];
        var titles = [
            'Patient',
            'Task Name',
            'Contract',
            'Created At',
            'Created By',
            'Task Status',
            'Address',
            'City',
            'Zip Code',
            'Caregiver',
            'Scheduled For',
            'Start Date',
            'Due Date',
            'Task Context',
            'Certification Start Date',
            'Certification End Date',
            'Documents',
            'Completion Date',
        ];
        rows.push(titles);


        const allChecks = $filter('filter')($scope.tableData, $scope.upcomingTasksGlobalFilter.val);
        allChecks.forEach(dataRow => {
            var csvRow = [];
            titles.forEach(title => {
                let toPush = "";
                switch (title) {
                    case 'Patient':
                        toPush = dataRow.patientName;
                        break;
                    case 'Task Name':
                        toPush = dataRow.title;
                        break;
                    case 'Contract':
                        toPush = dataRow.patientContractName || '';
                        break;
                    case 'Created At':
                        toPush = $filter('mfShortDate')(dataRow.createdAt) || '';
                        break;
                    case 'Created By':
                        toPush = $scope.agencyMembersMap[dataRow.createdBy] || '';
                        break;
                    case 'Task Status':
                        toPush = dataRow.status || '';
                        break;
                    case 'Address':
                        toPush = dataRow.patientAddress.text || '';
                        break;
                    case 'City':
                        toPush = dataRow.patientAddress.city || '';
                        break;
                    case 'Zip Code':
                        toPush = dataRow.patientAddress.zipCode || '';
                        break;
                    case 'Caregiver':
                        toPush = dataRow.caregiver ? dataRow.caregiver.displayName : "";
                        break;
                    case 'Scheduled For':
                        toPush = $filter('mfShortDate')(dataRow.scheduleDateTime) || '';
                        break;
                    case 'Start Date':
                        toPush = $filter('mfShortDate')(dataRow.startDate) || '';
                        break;
                    case 'Due Date':
                        toPush = $filter('mfShortDate')(dataRow.dueDate) || '';
                        break;
                    case 'Task Context':
                        toPush = dataRow.taskTemplateContextLabel;
                        break;
                    case 'Certification Start Date':
                        toPush = $filter('mfShortDate')(dataRow.certificationStartDate) || '';
                        break;
                    case 'Certification End Date':
                        toPush = $filter('mfShortDate')(dataRow.certificationEndDate) || '';
                        break;
                    case 'Documents':
                        toPush = dataRow.documents.map(doc => doc.title).join(", ");
                        break;
                    case 'Completion Date':
                        if (dataRow.completionDate && dataRow.originalCompletionDate) {
                            toPush = $filter('mfShortDate')(dataRow.originalCompletionDate);
                        } else {
                            toPush = '';
                        }
                        break;
                    default:
                        break;
                }
                csvRow.push("\"" + toPush + "\"");
            });

            rows.push(csvRow);
        });
        
        var csvContent = rows.map(rowArray => rowArray.join(",")).join("\r\n");

        var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", getExportedFileName());
        document.body.appendChild(link);

        link.click();
        $scope.loadingCSV = false;
    };

    var getExportedFileName = function () {
        var filename = "medflyt-upcoming-tasks-"
            + $filter("date")(new Date($scope.pageManager.searchParams.taskStartDate.value), "yyyy-MM-dd")
            + "-to-"
            + $filter("date")(new Date($scope.pageManager.searchParams.taskDueDate.value), "yyyy-MM-dd")
            + ".csv";
        return filename;
    }

    $scope.onClickRemovePatientScheduledDocument = function (document, task) {

        const modal = mfModal.create({
            subject: `Delete ${document.title} Document`,
            message: "Are you sure you want to delete this document?",
            variant: "danger",
            confirmLabel: "Confirm",
            cancelLabel: "Cancel",
            onConfirm: () => modal.close() && handleConfirmRemoveScheduledDocument(document, task)
        });
    };

    $scope.onClickExportFiles = () => {
        const selectedTasks = $scope.upcomingTasks.filter(x => x.selected && x.taskCanceledAt === null);
        if (selectedTasks.length === 0) {
            return toaster.pop('warning', 'No tasks selected');
        }
       const taskWithFiles = selectedTasks.map(x => {
        const [filled, missing] = partition(x.documents, x => x.submitted);
        return {
            title: `${x.patientName}, ${x.patientContractName} - task on ${x.startDate}`,
            patientId: x.patientId,
            documents: {
                filled,
                missing
            }
        }
       });
        console.log("selectedTasks", selectedTasks);
        const modal = mfModal.create({
            subject: `Export tasks files`,
            message: `We will create the files for these tasks: \n\n${taskWithFiles.map(x => x.title + ", " + x.documents.filled.length + " will be exported, " + x.documents.missing.length + " not completed").join("\n\n")}`,
            variant: "info",
            confirmLabel: "Yes,export",
            cancelLabel: "Cancel",
            onConfirm: () => modal.close() && $scope.zipFiles(taskWithFiles)
        });
    }

    $scope.zipFiles = function (taskWithFiles) {
        if (!taskWithFiles || taskWithFiles.length === 0) {
            return toaster.pop('warning', 'No tasks selected');
        }
        
        $scope.workingZip = true;
        var zip = new JSZip();
        var totalFiles = 0;
        var processedFiles = 0;

        // Count total files to process
        taskWithFiles.forEach(task => {
            totalFiles += task.documents.filled.length;
        });

        if (totalFiles === 0) {
            $scope.workingZip = false;
            return toaster.pop('warning', 'No files to export');
        }

        // Process each task
        taskWithFiles.forEach(task => {
            const taskFolder = zip.folder(task.title);
            
            // Process each filled document in the task
            task.documents.filled.forEach(doc => {
                if (doc.fileUrl && doc.fileUrl !== MANUAL_SUBMISSION_STRING) {
                    getFileUrl(doc.documentScheduleId, task.patientId)
                        .then(url => {
                            if (url) {
                                return fetch(url);
                            }
                            return null;
                        })
                        .then(response => {
                            if (response && (response.status === 200 || response.status === 0)) {
                                return response.blob();
                            }
                            return null;
                        })
                        .then(blob => {
                            if (blob) {
                                const fileName = `${doc.title}.pdf`;
                                taskFolder.file(fileName, blob);
                            }
                            processedFiles++;
                            
                            // Check if all files are processed
                            if (processedFiles === totalFiles) {
                                generateZipFile(zip);
                            }
                        })
                        .catch(error => {
                            console.error('Error processing file:', error);
                            processedFiles++;
                            if (processedFiles === totalFiles) {
                                generateZipFile(zip);
                            }
                        });
                } else {
                    processedFiles++;
                    if (processedFiles === totalFiles) {
                        generateZipFile(zip);
                    }
                }
            });
        });

        function generateZipFile(zip) {
            zip.generateAsync({ type: "blob" })
                .then(content => {
                    const blob = new Blob([content], { type: "application/zip" });
                    const url = $window.URL || $window.webkitURL;
                    $scope.zipFileUrl = url.createObjectURL(blob);
                    
                    // Create and trigger download
                    const link = document.createElement('a');
                    link.href = $scope.zipFileUrl;
                    link.download = 'medflyt-exported-files.zip';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    
                    $scope.workingZip = false;
                    $scope.haveZipFile = true;
                })
                .catch(error => {
                    console.error('Error generating zip file:', error);
                    toaster.pop('error', 'Error', 'Failed to generate zip file');
                    $scope.workingZip = false;
                });
        }
    };

    $scope.onClickTaskRow = (row) => {
        $scope.selectedTaskInstance = row;
    }

    $scope.onTaskMetricsModalClose = () => {
        $scope.selectedTaskInstance = null;
        $scope.$apply(); // Force AngularJS to detect the change
    }

    $scope.isStatusSelected = function(status) {
        return $scope.upcomingTasksFilters.statuses.some(s => s.id === status.id);
    };

    // Initialize task issues options for multiselect
    $scope.taskIssuesMultiSelectOptions = [];

    $scope.languagesMultiSelectOptions = $rootScope.allLanguages.map((lang) => ({
        id: lang,
        label: lang,
      }));
    
    // Fetch task issues from server
    tasksService.getTaskIssueTypes().then((taskIssueTypes) => {
        $scope.taskIssuesMultiSelectOptions = taskIssueTypes.map(issue => ({
            id: issue.code,
            label: issue.name
        }));
    }).catch(() => {
        toaster.pop('error', "Failed to load task issues");
    });

    $scope.upcomingTasksStatusMultiSelectOptions = tasksService.statuses;

    $rootScope.$on("got_data", function (event) {
        if ($scope.gotData) return;
        $scope.agencyMembersMap = DatabaseApi.getAgencyMembers();
        initialize();
    });

    $rootScope.$on("got_patient_document_types", function (event) {
        $scope.documentTypes = DatabaseApi.patientDocumentTypes();
        setDocumentsMultiSelectOptions();
    });

    $rootScope.$on("got_offices", function (event) {
        $scope.officesMap = DatabaseApi.offices();
        setOfficeMultiSelectOptions();
    });

    $rootScope.$on("got_patient_task_templates", function (event) {
        $scope.patientTaskTemplates = DatabaseApi.patientTaskTemplates();
    });


    $rootScope.$on("got_plan_of_care_type", function (event) {
        $scope.planOfCareTypes = DatabaseApi.plansOfCare();
        setPlanOfCareType();;
    });

    initialize();
};
